export const MAILING_LIST_ADDRESS_PAGE: boolean = true;
